"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SILENT_MODE = void 0;
exports.useBuildTestIdInternal = useBuildTestIdInternal;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _lodash = require("lodash");
var _error = require("../error.utils");
var _testIdBoundary = require("../providers/test-id-boundary.provider");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SILENT_MODE = exports.SILENT_MODE = false;
function getMiddleMessageOfDataTestIdError(valueName) {
  if (valueName === 'prefix') {
    return "you must wrap your component with 'TestIdBoundaryProvider'";
  }
  if (valueName === 'identifier') {
    return 'you must provide an identifier like: testIdName or id or name to your component';
  }
  return 'you need to supply in the ui component the suffix type';
}
var SAMPLE_RATE = 100;
function validateDataTestIdPartValue(_ref) {
  var value = _ref.value,
    valueName = _ref.valueName,
    enforce = _ref.enforce,
    testId = _ref.testId,
    prefix = _ref.prefix,
    identifier = _ref.identifier,
    suffix = _ref.suffix,
    componentName = _ref.componentName,
    testIdType = _ref.testIdType;
  if (value || testIdType) {
    return true;
  }
  if (SILENT_MODE) {
    return false;
  }
  var sampleNumber = Math.floor(Math.random() * SAMPLE_RATE);
  if (sampleNumber !== SAMPLE_RATE - 1) {
    return false;
  }
  var startOfMessage = "data-testid error: ".concat(componentName, " is missing the ").concat(valueName, " for the 'data-testid' prop");
  var middleOfMessage = getMiddleMessageOfDataTestIdError(valueName);
  var endOfMessage = "prefix: ".concat(prefix, "; identifier: ").concat(identifier, "; suffix: ").concat(suffix, ";");
  var log = "".concat(startOfMessage, ", ").concat(middleOfMessage, ". ").concat(endOfMessage);
  try {
    (0, _error.trackError)(log, {
      componentName: componentName,
      testId: testId,
      identifier: identifier,
      suffix: suffix
    });
  } catch (_unused) {
    // eslint-disable-next-line no-console
    console.error(log);
  }
  if (enforce) {
    throw new Error(log);
  }
  return false;
}
function useBuildTestIdInternal(_ref2) {
  var identifier = _ref2.identifier,
    suffix = _ref2.suffix,
    componentName = _ref2.componentName,
    testId = _ref2.testId,
    enforce = _ref2.enforce,
    testIdType = _ref2.testIdType;
  var _useContext = (0, _react.useContext)(_testIdBoundary.TestIdBoundaryContext),
    prefix = _useContext.prefix;
  return (0, _react.useMemo)(function () {
    if (testId) {
      return testId;
    }
    var commonValidateProps = {
      testId: testId,
      prefix: prefix,
      identifier: identifier,
      suffix: suffix,
      enforce: enforce,
      componentName: componentName,
      testIdType: testIdType
    };
    var isValid = validateDataTestIdPartValue(_objectSpread({
      value: prefix,
      valueName: 'prefix'
    }, commonValidateProps));
    isValid = isValid && validateDataTestIdPartValue(_objectSpread({
      value: identifier,
      valueName: 'identifier'
    }, commonValidateProps));
    isValid = isValid && validateDataTestIdPartValue(_objectSpread({
      value: suffix,
      valueName: 'suffix'
    }, commonValidateProps));
    if (!isValid) {
      return;
    }

    // We allow interactable to have test id type without test id for action buttons that exists in HBToast, HBDialog etc.
    // You can use TestIdType just inside this package.
    var isInteractableActionWithJustTestIdType = testIdType && (!prefix || !identifier || !suffix);
    if (isInteractableActionWithJustTestIdType) {
      return;
    }
    var formattedIdentifier = (0, _lodash.kebabCase)(identifier);
    return "".concat(prefix, "-").concat(formattedIdentifier, "--").concat(suffix);
  }, [testId, prefix, identifier, suffix, enforce, componentName, testIdType]);
}
//# sourceMappingURL=useBuildTestIdInternal.js.map